import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {BehaviorSubject} from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  
  captchSource = new BehaviorSubject(null);
  captchStatus = this.captchSource.asObservable(); 
  constructor(
    private cookieService: CookieService
  ) { }

  setCaptchaStatus(code) {
    this.captchSource.next(code);
    var date = new Date();
    date.setTime(date.getTime() + (10 * 1000));
    this.cookieService.set("securityCheck", code, { expires: 1, path: '', sameSite: 'Strict', secure: true });
    //this.cookieService.set("securityCheck", code, 1, '/account');
  }

}